import { SealCheck } from "@phosphor-icons/react";

const when = (iso) => {
  try {
    return new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return iso || "";
  }
};

const VIA = { manual: "Approved manually by staff", portal: "Signed in customer portal", link: "Signed via approval link" };

// Who approved the quote / drawing, when, how, and any note — shown on quote review and job overview.
export const ApprovalTrail = ({ quote, compact = false }) => {
  if (!quote) return null;
  const rows = [];
  const acc = quote.acceptance;
  if (acc?.at) rows.push({ what: "Quote accepted", who: acc.name || acc.email, at: acc.at, via: acc.via || (acc.signature_path ? "portal" : ""), note: acc.note, waived: acc.waived });
  const dr = quote.drawing_approval || {};
  if (dr.status === "approved" && dr.approved_at)
    rows.push({ what: "Drawing approved", who: dr.name, at: dr.approved_at, via: dr.via || "portal", note: dr.note, waived: dr.waived });
  if (!rows.length) return null;
  return (
    <div
      data-testid="approval-trail"
      className={`rounded-lg border border-emerald-500/25 bg-emerald-500/5 ${compact ? "px-3 py-2" : "p-4"}`}
    >
      <div className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-widest text-emerald-300">
        <SealCheck size={13} weight="bold" /> Approval trail
      </div>
      <ul className="mt-2 space-y-1.5">
        {rows.map((r) => (
          <li key={r.what} data-testid={`approval-trail-${r.what.toLowerCase().replace(/\s+/g, "-")}`} className="text-xs text-zinc-300">
            <span className="font-semibold text-zinc-100">{r.what}</span>
            {r.who ? <> by <span className="font-semibold text-emerald-200">{r.who}</span></> : null}
            <span className="text-zinc-500"> · {when(r.at)}</span>
            <span className="ml-2 rounded-full border border-zinc-700 px-1.5 py-0.5 text-[9px] uppercase tracking-wider text-zinc-400">
              {VIA[r.via] || r.via || "approved"}
              {r.waived ? " · no signature required" : ""}
            </span>
            {r.note && <div className="mt-0.5 text-[11px] italic text-zinc-400">“{r.note}”</div>}
          </li>
        ))}
      </ul>
    </div>
  );
};
